export default function alertService() {
  return function generate(viewField, engineApi) {
    viewField.metadata = viewField.metadata || {};
    return new engineApi.Element('ec-alert')
      .addAttribute('title', viewField.metadata.title || '')
      .addAttribute('closable', viewField.metadata.closable || false)
      .addAttribute('content', viewField.metadata.text || viewField.metadata.content || '')
      .addAttribute('icon', viewField.metadata.icon)
      .addAttribute(`ec-${viewField.metadata.style || 'warning'}`, '')
      .addAttribute('ec-flex', viewField.cols || '8')
      .addAttribute('ng-show', engineApi.property.getVisible(viewField), true);
  };
}
